import { Component } from '@angular/core';

@Component({
  selector: 'rr-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class RRCardComponent {
  constructor() {}
}
